var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.5H1.5C1.23488 0.500303 0.980699 0.605757 0.793228 0.793228C0.605757 0.980699 0.500303 1.23488 0.5 1.5V8.5C0.500303 8.76512 0.605757 9.0193 0.793228 9.20677C0.980699 9.39424 1.23488 9.4997 1.5 9.5H14.5C14.7651 9.4997 15.0193 9.39424 15.2068 9.20677C15.3942 9.0193 15.4997 8.76512 15.5 8.5V1.5C15.4997 1.23488 15.3942 0.980699 15.2068 0.793228C15.0193 0.605757 14.7651 0.500303 14.5 0.5ZM4.68497 8.5L1.5 5.77003V4.22997L4.68497 1.5H11.315L14.5002 4.23016L14.5004 5.76971L11.315 8.5H4.68497ZM10.5 5C10.5 5.49445 10.3534 5.9778 10.0787 6.38893C9.80397 6.80005 9.41352 7.12048 8.95671 7.3097C8.49989 7.49892 7.99723 7.54843 7.51227 7.45196C7.02732 7.3555 6.58186 7.1174 6.23223 6.76777C5.8826 6.41814 5.6445 5.97268 5.54804 5.48773C5.45157 5.00277 5.50108 4.50011 5.6903 4.04329C5.87952 3.58648 6.19995 3.19603 6.61107 2.92133C7.0222 2.64662 7.50555 2.5 8 2.5C8.66281 2.50076 9.29825 2.76439 9.76693 3.23307C10.2356 3.70175 10.4992 4.33719 10.5 5Z",
    fill: "#C1AF82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.eb8cd1d823315a1f1065de18578e6574.svg";
export { ForwardRef as ReactComponent };